// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  min-height: 100%;
  background-attachment: fixed;
  background-image: url("/assets/images/background-pattern.svg"), linear-gradient(rgb(0, 158, 218), rgb(0, 124, 190));
  height: 100%;
  overflow: auto;
}

.login-container .container {
  padding-bottom: 50px;
}

#logo {
  background-image: url("/assets/images/nice-logo-black-with-white.svg");
  background-repeat: no-repeat;
  background-position: top left;
  background-size: 76px 30px;
  margin: 50px auto 18px;
  padding-top: 30px;
}
@media (max-height: 600px) {
  #logo {
    margin-top: 30px;
  }
}

#btnLogin {
  margin: 0;
  font-family: "Open Sans";
  font-size: 14px;
  border-radius: 3px;
  text-decoration: none;
  box-sizing: border-box;
  min-width: 110px;
  height: 40px;
}

.card {
  margin-bottom: 50px;
}
.card .card-body {
  padding: 2rem;
}
.card .card-body.wfm-login-title {
  padding-top: 1rem;
  padding-bottom: 0.5rem;
  font-size: 18px;
}
@media (max-width: 575.98px) {
  .card .card-body {
    padding-left: 1.2rem;
    padding-right: 1.2rem;
  }
}
.card .wfm-login-title {
  border-bottom: 1px solid #adb5bd;
}

.language .wfm-input-group label {
  font-size: 13px;
  text-transform: uppercase;
  padding-left: 0;
  font-weight: 400;
  color: #9aa4ab;
  display: block;
  position: static;
  margin-bottom: 0.25rem;
}

footer.copyRight-contactUs {
  color: #fff;
  text-align: center;
  width: 100%;
  display: block;
  padding: 0;
  margin: -50px auto 0;
  height: 50px;
}

.wfm-input-group .form-control {
  height: calc(2.5rem + 2px);
}

.text-danger {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
}

.login-loading-content {
  padding: 20px;
  background-color: #E1EAF2;
  display: flex;
  flex-flow: column nowrap;
  max-height: 100vh;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
.login-loading-content .page-header {
  flex: 0 0 50px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  margin-top: 5px;
}

.vertical-center {
  min-height: 100%; /* Fallback for vh unit */
  min-height: 100vh; /* You might also want to use
   'height' property instead.

   Note that for percentage values of
   'height' or 'min-height' properties,
   the 'height' of the parent element
   should be specified explicitly.

   In this case the parent of '.vertical-center'
   is the <body> element */
  /* Make it a flex container */
  display: flex;
  /* Align the bootstrap's container vertically */
  align-items: center;
  /* In legacy web browsers such as Firefox 9
     we need to specify the width of the flex container */
  width: 100%;
  /* Also 'margin: 0 auto' doesn't have any effect on flex items in such web browsers
     hence the bootstrap's container won't be aligned to the center anymore.

     Therefore, we should use the following declarations to get it centered again */
  justify-content: center;
}

.input-group-password {
  justify-content: flex-end;
}

.input-txt-error {
  border-color: #dc3545;
}

div.input-group-text.is-invalid {
  height: 65%;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/login-page/login-page.component.scss","webpack://./../PSR%20ESP%20WebApp%20Build/src/app/pages/login-page/login-page.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,4BAAA;EACA,mHAAA;EACA,YAAA;EACA,cAAA;ACCF;;ADCA;EACE,oBAAA;ACEF;;ADIA;EACE,sEAAA;EACA,4BAAA;EACA,6BAAA;EACA,0BAAA;EACA,sBAAA;EACA,iBAAA;ACDF;ADEE;EAPF;IAQI,gBAAA;ECCF;AACF;;ADCA;EACE,SAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;ACEF;;ADAA;EACE,mBAAA;ACGF;ADFE;EACE,aAAA;ACIJ;ADHI;EACE,iBAAA;EACA,sBAAA;EACA,eAAA;ACKN;ADHI;EAPF;IAQI,oBAjCoB;IAkCpB,qBAlCoB;ECwCxB;AACF;ADJE;EACE,gCAAA;ACMJ;;ADHA;EACE,eAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;ACMF;;ADHA;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,UAAA;EACA,oBAAA;EACA,YAAA;ACMF;;ADHA;EACE,0BAAA;ACMF;;ADHA;EACE,WAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;ACMF;;ADHA;EAEE,aAAA;EACA,yBAAA;EACA,aAAA;EACA,wBAAA;EACA,iBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;ACKF;ADJE;EACE,cAAA;EACA,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;ACMJ;;ADFA;EACE,gBAAA,EAAA,yBAAA;EACA,iBAAA,EAAA;;;;;;;;;0BAAA;EAWA,6BAAA;EAKA,aAAA;EAEA,+CAAA;EAKQ,mBAAA;EAER;yDAAA;EAEA,WAAA;EAEA;;;mFAAA;EAQQ,uBAAA;ACCV;;ADGA;EACE,yBAAA;ACAF;;ADGA;EACE,qBAAA;ACAF;;ADGA;EACE,WAAA;ACAF","sourcesContent":[".login-container {\n  min-height: 100%;\n  background-attachment: fixed;\n  background-image: url(\"/assets/images/background-pattern.svg\"), linear-gradient(rgb(0, 158, 218), rgb(0, 124, 190));\n  height: 100%;\n  overflow: auto;\n}\n.login-container .container {\n  padding-bottom: 50px;\n}\n\n$card-content-padding-lg: 2.5rem;\n$card-content-padding-xs: 1.2rem;\n\n#logo {\n  background-image: url(\"/assets/images/nice-logo-black-with-white.svg\");\n  background-repeat: no-repeat;\n  background-position: top left;\n  background-size: 76px 30px;\n  margin: 50px auto 18px;\n  padding-top: 30px;\n  @media (max-height: 600px) {\n    margin-top: 30px;\n  }\n}\n#btnLogin{\n  margin:0;\n  font-family: \"Open Sans\";\n  font-size: 14px;\n  border-radius: 3px;\n  text-decoration: none;\n  box-sizing: border-box;\n  min-width: 110px;\n  height: 40px;\n}\n.card {\n  margin-bottom: 50px;\n  .card-body {\n    padding: 2rem;\n    &.wfm-login-title {\n      padding-top: 1rem;\n      padding-bottom: .5rem;\n      font-size: 18px;\n    }\n    @media (max-width: 575.98px) {\n      padding-left: $card-content-padding-xs;\n      padding-right: $card-content-padding-xs;\n    }\n  }\n  .wfm-login-title {\n    border-bottom: 1px solid #adb5bd;\n  }\n}\n.language .wfm-input-group label {\n  font-size: 13px;\n  text-transform: uppercase;\n  padding-left: 0;\n  font-weight: 400;\n  color: #9aa4ab;\n  display: block;\n  position: static;\n  margin-bottom: .25rem;\n}\n\nfooter.copyRight-contactUs {\n  color: #fff;\n  text-align: center;\n  width: 100%;\n  display: block;\n  padding: 0;\n  margin: -50px auto 0;\n  height: 50px;\n}\n\n.wfm-input-group .form-control {\n  height: calc(2.5rem + 2px);\n}\n\n.text-danger {\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 80%;\n  color: #dc3545;\n}\n\n.login-loading-content {\n\n  padding: 20px;\n  background-color: #E1EAF2;\n  display: flex;\n  flex-flow: column nowrap;\n  max-height: 100vh;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  .page-header {\n    flex: 0 0 50px;\n    display: flex;\n    flex-flow: row nowrap;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 5px;\n  }\n}\n\n.vertical-center {\n  min-height: 100%;  /* Fallback for vh unit */\n  min-height: 100vh; /* You might also want to use\n                        'height' property instead.\n\n                        Note that for percentage values of\n                        'height' or 'min-height' properties,\n                        the 'height' of the parent element\n                        should be specified explicitly.\n\n                        In this case the parent of '.vertical-center'\n                        is the <body> element */\n\n  /* Make it a flex container */\n  display: -webkit-box;\n  display: -moz-box;\n  display: -ms-flexbox;\n  display: -webkit-flex;\n  display: flex;\n\n  /* Align the bootstrap's container vertically */\n    -webkit-box-align : center;\n  -webkit-align-items : center;\n       -moz-box-align : center;\n       -ms-flex-align : center;\n          align-items : center;\n\n  /* In legacy web browsers such as Firefox 9\n     we need to specify the width of the flex container */\n  width: 100%;\n\n  /* Also 'margin: 0 auto' doesn't have any effect on flex items in such web browsers\n     hence the bootstrap's container won't be aligned to the center anymore.\n\n     Therefore, we should use the following declarations to get it centered again */\n         -webkit-box-pack : center;\n            -moz-box-pack : center;\n            -ms-flex-pack : center;\n  -webkit-justify-content : center;\n          justify-content : center;\n}\n\n\n.input-group-password {\n  justify-content: flex-end;\n}\n\n.input-txt-error {\n  border-color: #dc3545;\n}\n\ndiv.input-group-text.is-invalid {\n  height: 65%;\n}\n",".login-container {\n  min-height: 100%;\n  background-attachment: fixed;\n  background-image: url(\"/assets/images/background-pattern.svg\"), linear-gradient(rgb(0, 158, 218), rgb(0, 124, 190));\n  height: 100%;\n  overflow: auto;\n}\n\n.login-container .container {\n  padding-bottom: 50px;\n}\n\n#logo {\n  background-image: url(\"/assets/images/nice-logo-black-with-white.svg\");\n  background-repeat: no-repeat;\n  background-position: top left;\n  background-size: 76px 30px;\n  margin: 50px auto 18px;\n  padding-top: 30px;\n}\n@media (max-height: 600px) {\n  #logo {\n    margin-top: 30px;\n  }\n}\n\n#btnLogin {\n  margin: 0;\n  font-family: \"Open Sans\";\n  font-size: 14px;\n  border-radius: 3px;\n  text-decoration: none;\n  box-sizing: border-box;\n  min-width: 110px;\n  height: 40px;\n}\n\n.card {\n  margin-bottom: 50px;\n}\n.card .card-body {\n  padding: 2rem;\n}\n.card .card-body.wfm-login-title {\n  padding-top: 1rem;\n  padding-bottom: 0.5rem;\n  font-size: 18px;\n}\n@media (max-width: 575.98px) {\n  .card .card-body {\n    padding-left: 1.2rem;\n    padding-right: 1.2rem;\n  }\n}\n.card .wfm-login-title {\n  border-bottom: 1px solid #adb5bd;\n}\n\n.language .wfm-input-group label {\n  font-size: 13px;\n  text-transform: uppercase;\n  padding-left: 0;\n  font-weight: 400;\n  color: #9aa4ab;\n  display: block;\n  position: static;\n  margin-bottom: 0.25rem;\n}\n\nfooter.copyRight-contactUs {\n  color: #fff;\n  text-align: center;\n  width: 100%;\n  display: block;\n  padding: 0;\n  margin: -50px auto 0;\n  height: 50px;\n}\n\n.wfm-input-group .form-control {\n  height: calc(2.5rem + 2px);\n}\n\n.text-danger {\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 80%;\n  color: #dc3545;\n}\n\n.login-loading-content {\n  padding: 20px;\n  background-color: #E1EAF2;\n  display: flex;\n  flex-flow: column nowrap;\n  max-height: 100vh;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n}\n.login-loading-content .page-header {\n  flex: 0 0 50px;\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 5px;\n}\n\n.vertical-center {\n  min-height: 100%; /* Fallback for vh unit */\n  min-height: 100vh; /* You might also want to use\n   'height' property instead.\n\n   Note that for percentage values of\n   'height' or 'min-height' properties,\n   the 'height' of the parent element\n   should be specified explicitly.\n\n   In this case the parent of '.vertical-center'\n   is the <body> element */\n  /* Make it a flex container */\n  display: -webkit-box;\n  display: -moz-box;\n  display: -ms-flexbox;\n  display: -webkit-flex;\n  display: flex;\n  /* Align the bootstrap's container vertically */\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -moz-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  /* In legacy web browsers such as Firefox 9\n     we need to specify the width of the flex container */\n  width: 100%;\n  /* Also 'margin: 0 auto' doesn't have any effect on flex items in such web browsers\n     hence the bootstrap's container won't be aligned to the center anymore.\n\n     Therefore, we should use the following declarations to get it centered again */\n  -webkit-box-pack: center;\n  -moz-box-pack: center;\n  -ms-flex-pack: center;\n  -webkit-justify-content: center;\n  justify-content: center;\n}\n\n.input-group-password {\n  justify-content: flex-end;\n}\n\n.input-txt-error {\n  border-color: #dc3545;\n}\n\ndiv.input-group-text.is-invalid {\n  height: 65%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
